export default __webpack_public_path__ + "static/media/aws-ssm-tunnel.4546c0ec.md";